module.exports = __webpack_public_path__ + "static/media/24-skylder.aa27621f.mp3";